import styled, { css } from 'styled-components'

export const MoreFilterButtonWrapper = styled.div<{ multiFilter: boolean }>`
    display: flex;
    ${({ multiFilter }) => {
        if (!multiFilter) {
            return 'justify-content: flex-end;'
        }
        return css`
        justify-content: space-between;
        `
    }}
    button {
        svg {
            margin-right: 10px;
        }
    }
`
